import {useErrorContext} from "../../model/ErrorContext";
import {ErrorCodes} from "../../model/ErrorCodes";
import {useMemo} from "react";

export default function ErrorMessages()
{
    const { errors } = useErrorContext();
    const messages = useMemo(() => {
        const messages = {};

        messages[ErrorCodes.SeatsTooBigForRoom] = "De zetels passen niet in de kamer.";
        messages[ErrorCodes.SeatsTooWideForAisle] = "De zetels zijn te breed voor de doorgang.";
        messages[ErrorCodes.SeatsTooFar] = "De primaire zitpositie is te ver van het scherm. We stellen voor om de primaire zitpositie te wijzigen, het scherm te vergroten of de zitpositie te verschuiven.";
        messages[ErrorCodes.SeatsTooNear] = "De primaire zitpositie is te dicht bij het scherm. We stellen voor om de primaire zitpositie te wijzigen, het scherm te verkleinen of de zitpositie te verschuiven.";
        messages[ErrorCodes.MultipleSeatingRows] = "Bij meerdere zitrijen is het belangrijk om de zichtlijnen te controleren en eventueel aan te passen naargelang de mogelijkheden van de ruimte. Voor meer informatie kan u ons steeds contacteren.";

        messages[ErrorCodes.ProjectorTooFar] = "De projector staat te ver van het scherm.";
        messages[ErrorCodes.ProjectorTooNear] = "De projector staat te dicht bij het scherm.";

        messages[ErrorCodes.ScreenTooLarge] = "Het scherm is te groot.";
        messages[ErrorCodes.ScreenTooSmall] = "Het scherm is te klein.";

        messages[ErrorCodes.CeilingSpeakersTooLow] = "De plafond luidsprekers staan te laag ten opzichte van de primaire zitpositie.";
        messages[ErrorCodes.CeilingSpeakersTooCloseToWalls] = "De plafond luidsprekers staan te dicht bij de muur.";
        messages[ErrorCodes.CeilingSpeakersWrongAngle] = "Er is niet voldoende ruimte voor de plafond luidsprekers.";
        messages[ErrorCodes.CeilingSpeakersWrongAngleFront] = "Er is niet voldoende ruimte voor de voorste plafond luidsprekers.";
        messages[ErrorCodes.CeilingSpeakersWrongAngleRear] = "Er is niet voldoende ruimte voor de achterste plafond luidsprekers.";

        messages[ErrorCodes.FrontSpeakersBlockScreen] = "Luidsprekers vooraan blokkeren het scherm.";
        messages[ErrorCodes.FrontSpeakersWrongAngle] = "Luidspreker vooraan staat niet in een ideale hoek.";
        messages[ErrorCodes.FrontSpeakersTooCloseToWalls] = "Luidsprekers vooraan staan te dicht bij de muur.";
        messages[ErrorCodes.FrontSpeakersNotBehindAcousticScreen] = "Luidsprekers vooraan staan niet volledig achter het scherm. Het scherm dient minimum 270cm breed te zijn."

        messages[ErrorCodes.SideSpeakersWrongAngle] = "De zijdelingse speakers staan niet in een ideale hoek.";

        messages[ErrorCodes.RearSpeakersWrongAngle] = "Er is niet voldoende ruimte voor de achterste luidsprekers.";
        messages[ErrorCodes.RearSpeakersTooCloseToSelf] = "Luidsprekers achteraan staan te dicht bij elkaar.";
        messages[ErrorCodes.RearSpeakersTooCloseToWall] = "Luidsprekers achteraan staan te dicht bij de muur.";

        return messages;
    },  []);
    return <div><h3>Meldingen</h3>
        {
            errors.map((elm, i) =>
                <p key={i}>{ messages[elm] }</p>
            )
        }
    </div>
}
